import { render, staticRenderFns } from "./productBrochureStyle.vue?vue&type=template&id=aa5d9c18&scoped=true"
import script from "./productBrochureStyle.vue?vue&type=script&lang=js"
export * from "./productBrochureStyle.vue?vue&type=script&lang=js"
import style0 from "./productBrochureStyle.vue?vue&type=style&index=0&id=aa5d9c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5d9c18",
  null
  
)

export default component.exports